import { PersonalInfo } from '../types';

export const personalInfo: PersonalInfo = {
  name: "Osama Abd Al Malik",
  title: "Software Engineer",
  subtitle: "Backend & Mobile App Developer",
  description: "Building scalable, secure, and high-performance solutions across Laravel backends, RESTful APIs, microservices, and Flutter mobile applications",
  email: "osamaaabdalmalik@gmail.com",
  phone: "+963 996 697 253",
  location: "Damascus, Syria",
  github: "https://github.com/osamaaabdalmalik",
  gitlab: "https://gitlab.com/osamaaabdalmalik",
  behance: "https://behance.net/osamaaabdalmalik",
  facebook: "https://facebook.com/osamaaabdalmalik",
  instagram: "https://instagram.com/osamaaabdalmalik",
  
  about: {
    professionalJourney: {
      title: "Professional Journey",
      description: "with 5+ years of experience building scalable, secure, and high-performance solutions. Specialized in Laravel backends, RESTful APIs, microservices, real-time features (WebSockets, FCM), and Flutter apps with clean architecture and advanced state management across banking, e-commerce, healthcare, and social impact sectors."
    },
    leadershipImpact: {
      title: "Leadership & Impact", 
      description: "Proven team leader with production experience delivering backends for 100K+ users and 20+ published mobile apps with 99.5% crash-free rates. Strong in system architecture, DevOps (Docker, Nginx, Redis, CI/CD), and production-ready delivery."
    }
  },
  
  coreExpertise: [
    "Laravel PHP & RESTful APIs",
    "Flutter & Dart (5+ years)",
    "System Architecture & Microservices",
    "Clean Architecture & SOLID Principles",
    "State Management (BLoC, Provider, Riverpod)",
    "DevOps: Docker, Nginx, Redis, CI/CD",
    "Team Leadership & Mentoring",
  ]
};